export enum DomainMeta {
  MODEL = "domain",
  PK = "id",
}

export enum RecordType {
  A = "A",
  AAAA = "AAAA",
  CNAME = "CNAME",
  MX = "MX",
  NS = "NS",
  SRV = "SRV",
  SSHPF = "SSHFP",
  TXT = "TXT",
}
